/* use JavaScript pass by reference i.e for productConfiguration array */
const transformHomeServicesProducts = (homeServices, productConfiguration) => {
  if (homeServices?.testDrive) {
    productConfiguration.push('dhs-test-drive');
  }
  if (homeServices?.vehicleDelivery) {
    productConfiguration.push('dhs-deliver');
  }
  if (homeServices?.virtualTour) {
    productConfiguration.push('dhs-video');
  }
  if (homeServices?.accelerate) {
    productConfiguration.push('online-paperwork');
  }
  if (homeServices?.serviceInquiry === 'scheduleTestDrive') {
    productConfiguration.push('schedule-test-drive');
  }
  if (homeServices?.buyOnline) {
    productConfiguration.push('buy-online');
  }
};
export function transformProductConfig(products, includeWalletData) {
  if (products === void 0) {
    products = {};
  }
  if (includeWalletData === void 0) {
    includeWalletData = false;
  }
  const productConfiguration = [];
  const {
    homeServices = {},
    nds,
    wallet,
    shippingLabel,
    creditApp,
    westlake
  } = products;
  transformHomeServicesProducts(homeServices, productConfiguration);
  if (wallet || includeWalletData) productConfiguration.push('my-wallet');
  if (nds) productConfiguration.push('nds');
  if (shippingLabel) productConfiguration.push('me-delivery');
  if (creditApp) productConfiguration.push('credit-app');
  if (westlake) productConfiguration.push('westlake');
  return {
    productConfiguration: productConfiguration.length > 0 ? productConfiguration.join('|') : undefined
  };
}
export const hasPrice = function (_temp) {
  let {
    pricingDetail
  } = _temp === void 0 ? {} : _temp;
  return pricingDetail?.salePrice || pricingDetail?.msrp;
};
export default {
  transformProductConfig,
  hasPrice
};